import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './TopBar.css';
import img from '../assets/logo/logo1.jpeg';

function TopBar() {
  const [dateTime, setDateTime] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();

      const formattedDate = new Intl.DateTimeFormat('en-IN', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(now);

      const formattedTime = new Intl.DateTimeFormat('en-IN', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).format(now);

      setDateTime(`${formattedDate} | ${formattedTime}`);
    };

    updateDateTime();
    const i = setInterval(updateDateTime, 60000);
    return () => clearInterval(i);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentQuery = params.get('q') || '';

    if (location.pathname === '/search') {
      setSearchQuery(currentQuery);
      return;
    }

    setSearchQuery('');
  }, [location.pathname, location.search]);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const trimmedQuery = searchQuery.trim();

    if (!trimmedQuery) {
      return;
    }

    navigate(`/search?q=${encodeURIComponent(trimmedQuery)}`);
  };

  return (
    <div className="topbar">
      <div className="topbar-container">
        {/* Logo */}
        <div className="topbar-logo">
          <img src={img} alt=" लाठ साब" className="logo-img" />
          <div className="logo-text">
            <span className="logo-name"> </span>
            <span className="logo-tagline"><b>मिट्टी से मंत्रालय तक</b></span>
          </div>
        </div>

        {/* Date (hidden on small mobile) */}
        <div className="topbar-date">
           <span>{dateTime}</span>
        </div>

        {/* Search */}
        <form className="topbar-search" onSubmit={handleSearchSubmit} role="search">
          <input 
            type="text" 
            placeholder="खोजें..." 
            className="search-input"
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
            aria-label="Search news"
          />
          <button type="submit" className="search-btn">🔍</button>
        </form>
      </div>
    </div>
  );
}

export default TopBar;